import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-role-redirect',
  standalone: true,
  template: `
    <div class="min-h-screen flex items-center justify-center bg-gray-50">
      <div
        class="animate-spin w-8 h-8 border-4 border-brand border-t-transparent rounded-full"
      ></div>
    </div>
  `,
  styles: [
    `
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
      .animate-spin {
        animation: spin 1s linear infinite;
      }
    `,
  ],
})
export class RoleRedirectComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    this.authService
      .isAuthenticated()
      .pipe(take(1))
      .subscribe((isAuth) => {
        if (!isAuth) {
          // Not authenticated, go to landing
          this.router.navigate(['/']);
          return;
        }

        // Authenticated, check role and redirect
        this.authService
          .isStudent()
          .pipe(take(1))
          .subscribe({
            next: (isStudent) => {
              if (isStudent) {
                this.router.navigate(['/student/dashboard']);
              } else {
                this.router.navigate(['/teacher/dashboard']);
              }
            },
            error: () => {
              this.router.navigate(['/']);
            },
          });
      });
  }
}
